import actions from '@/store/zipCodes/actions';

const zipCodesModule = {
  state: () => ({
    zipCodes: [],
  }),
  getters: {
    sortedZipCodes(state) {
      return state.zipCodes ? state.zipCodes.sort((a, b) => a.zip - b.zip) : [];
    },
  },
  mutations: {
    GET_ZIP_CODES_SUCCESS(state, data) {
      state.zipCodes = data;
    },
  },
  actions,
  namespaced: true,
};

export default zipCodesModule;
